export enum FormField {
    Name = "name",
    EveningParticipation = "eveningParticipation",
    FeeType = "feeType",
    NameOfAccommodation = "nameOfAccommodation",
    PlaceOfAccommodation = "placeOfAccommodation",
    Email = "email",
    LastName = "lastName",
    Address = "address",
    BirthDate = "birthDate",
    IdNumber = "idNumber",
    AccommodationType = "accommodationType",
    ParticipationFee = "participationFee",
    PhoneNumber = "phoneNumber",
    MembershipNumber = "membershipNumber",
    StayDatesMultiple = "stayDatesMultiple",
}